(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sidiz-product-film"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sidiz-product-film-player')) {
    customElements.define('sidiz-product-film-player', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.video = this.querySelector('video');
        this.sound = this.querySelector('[data-sound-toggle]');
        if (!this.video || !this.sound) return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.connection = navigator.connection;
        this.inView = false;
        this.attempted = this.attempted || false;
        this.userControlled = this.userControlled || false;
        this.loading = false;
        this.systemPause = false;
        this.onCanPlay = () => this.startWhenReady();
        this.onVisibility = () => document.hidden ? this.suspend() : this.startWhenReady();
        this.onPreference = () => {
          if (!this.autoAllowed() && !this.userControlled) this.suspend();
          else this.prepare();
        };
        this.video.addEventListener('canplay', this.onCanPlay, options);
        this.video.addEventListener('volumechange', () => this.updateSound(), options);
        this.video.addEventListener('pause', () => {
          if (!this.systemPause) this.userControlled = true;
          this.systemPause = false;
        }, options);
        this.video.addEventListener('ended', () => { this.userControlled = true; }, options);
        this.video.addEventListener('pointerdown', () => { this.userControlled = true; }, options);
        this.video.addEventListener('keydown', () => { this.userControlled = true; }, options);
        this.sound.addEventListener('click', () => {
          this.userControlled = true;
          this.video.muted = !(this.video.muted || this.video.volume === 0);
          if (!this.video.muted && this.video.volume === 0) this.video.volume = 1;
          if (!this.video.muted && this.video.paused && !this.video.ended) {
            this.video.play().catch(() => {});
          }
          this.updateSound();
        }, options);
        document.addEventListener('visibilitychange', this.onVisibility, options);
        this.motion.addEventListener('change', this.onPreference);
        this.connection?.addEventListener('change', this.onPreference);
        this.querySelector('.sidiz-product-film__playback').hidden = false;
        this.updateSound();
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.inView = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.5;
            if (this.inView) this.prepare();
            else this.suspend();
          }, { threshold: [0, 0.5] });
          this.observer.observe(this.video);
        }
      }

      autoAllowed() {
        return this.dataset.autoplay === 'true' && !this.motion.matches && !this.connection?.saveData;
      }

      prepare() {
        if (!this.inView || document.hidden || !this.autoAllowed() || this.userControlled || this.attempted) return;
        if (!this.loading && this.video.readyState < 2) {
          this.loading = true;
          this.video.preload = 'auto';
          this.video.load();
        }
        this.startWhenReady();
      }

      startWhenReady() {
        if (!this.inView || document.hidden || !this.autoAllowed() || this.userControlled || this.attempted || this.video.readyState < 2) return;
        this.attempted = true;
        this.video.muted = true;
        this.video.play().then(() => {
          if (!this.inView || document.hidden) this.suspend();
        }).catch(() => {});
      }

      suspend() {
        if (!this.video.paused) {
          this.systemPause = true;
          this.video.pause();
        }
      }

      updateSound() {
        const quiet = this.video.muted || this.video.volume === 0;
        const label = quiet ? 'Turn sound on' : 'Mute sound';
        this.sound.setAttribute('aria-label', label);
        this.sound.title = label;
        this.sound.querySelector('[data-sound-label]').textContent = quiet ? 'Sound on' : 'Mute';
        this.sound.querySelector('[data-sound-on]').toggleAttribute('hidden', !quiet);
        this.sound.querySelector('[data-sound-off]').toggleAttribute('hidden', quiet);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.events?.abort();
        this.motion?.removeEventListener('change', this.onPreference);
        this.connection?.removeEventListener('change', this.onPreference);
        this.video?.pause();
        this.events = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sidiz-product-story-film"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sidiz-product-story-player')) {
    customElements.define('sidiz-product-story-player', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.video = this.querySelector('video');
        this.frame = this.querySelector('.sidiz-story-film__frame');
        this.playButton = this.querySelector('[data-play-toggle]');
        this.soundButton = this.querySelector('[data-sound-toggle]');
        if (!this.video || !this.frame || !this.playButton || !this.soundButton) return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.viewport = window.matchMedia('(max-width: 749px)');
        this.connection = navigator.connection;
        this.inView = false;
        this.autoAttempted = this.autoAttempted || false;
        this.manualPaused = this.manualPaused || false;
        this.systemPauses = 0;
        this.playRequest = (this.playRequest || 0) + 1;
        this.loadStarted = false;
        this.restore = null;
        this.video.addEventListener('loadedmetadata', () => this.restoreSource(), options);
        this.video.addEventListener('canplay', () => this.maybeAutoplay(), options);
        this.video.addEventListener('volumechange', () => this.updateControls(), options);
        this.video.addEventListener('play', () => {
          this.autoAttempted = true;
          this.manualPaused = false;
          if (this.playMode === 'auto' && (!this.inView || document.hidden || !this.autoAllowed())) this.suspend();
          this.updateControls();
        }, options);
        this.video.addEventListener('pause', () => {
          if (this.systemPauses > 0) this.systemPauses -= 1;
          else if (!this.restore) {
            this.manualPaused = true;
            this.autoAttempted = true;
          }
          this.updateControls();
        }, options);
        this.video.addEventListener('ended', () => {
          this.manualPaused = true;
          this.autoAttempted = true;
          this.updateControls();
        }, options);
        this.video.addEventListener('error', () => this.updateControls(), options);
        const nativeInteraction = () => {
          this.playMode = 'user';
          this.autoAttempted = true;
        };
        this.video.addEventListener('pointerdown', nativeInteraction, options);
        this.video.addEventListener('keydown', nativeInteraction, options);
        this.playButton.addEventListener('click', () => {
          if (this.video.paused) {
            this.manualPaused = false;
            this.autoAttempted = true;
            if (this.restore) this.restore.wasPlaying = true;
            this.playVideo('user');
          } else {
            this.manualPaused = true;
            this.autoAttempted = true;
            if (this.restore) this.restore.wasPlaying = false;
            this.playRequest += 1;
            this.video.pause();
          }
        }, options);
        this.soundButton.addEventListener('click', () => {
          this.autoAttempted = true;
          this.video.muted = !(this.video.muted || this.video.volume === 0);
          if (!this.video.muted && this.video.volume === 0) this.video.volume = 1;
          if (this.restore) {
            this.restore.muted = this.video.muted;
            this.restore.volume = this.video.volume;
          }
          this.updateControls();
        }, options);
        this.onViewport = () => this.selectSource(true);
        this.onPreference = () => {
          if (!this.autoAllowed() && this.playMode === 'auto') this.suspend();
          else this.prepare();
        };
        this.onVisibility = () => document.hidden ? this.suspend() : this.prepare();
        this.viewport.addEventListener('change', this.onViewport);
        this.motion.addEventListener('change', this.onPreference);
        this.connection?.addEventListener('change', this.onPreference);
        document.addEventListener('visibilitychange', this.onVisibility, options);
        this.selectSource(false);
        this.querySelector('.sidiz-story-film__controls').hidden = false;
        this.updateControls();
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            const entry = entries[entries.length - 1];
            this.inView = entry.isIntersecting && entry.intersectionRatio >= 0.5;
            if (this.inView) this.prepare();
            else this.suspend();
          }, { threshold: [0, 0.5] });
          this.observer.observe(this.video);
        }
      }

      autoAllowed() {
        return this.dataset.autoplay === 'true' && !this.motion.matches && !this.connection?.saveData;
      }

      selectSource(preserve) {
        const mobile = this.viewport.matches && Boolean(this.dataset.mobileSrc);
        const source = mobile ? this.dataset.mobileSrc : this.dataset.desktopSrc;
        const poster = mobile ? (this.dataset.mobilePoster || this.dataset.desktopPoster) : this.dataset.desktopPoster;
        this.dataset.activeSource = mobile ? 'mobile' : 'desktop';
        this.frame.style.aspectRatio = mobile ? (this.dataset.mobileRatio || '16 / 9') : '16 / 9';
        if (poster) this.video.setAttribute('poster', poster);
        else this.video.removeAttribute('poster');
        if (!source || this.video.getAttribute('src') === source) return;
        const previous = this.restore;
        const hadMedia = this.loadStarted || this.video.readyState > 0 || this.video.currentTime > 0;
        this.restore = preserve ? {
          time: previous ? previous.time : this.video.currentTime,
          muted: previous ? previous.muted : this.video.muted,
          volume: previous ? previous.volume : this.video.volume,
          wasPlaying: previous ? previous.wasPlaying : !this.video.paused,
          mode: previous ? previous.mode : (this.playMode || 'user'),
          tracks: previous ? previous.tracks : Array.from(this.video.textTracks || []).map(track => track.mode)
        } : null;
        this.suspend(false);
        this.video.setAttribute('src', source);
        this.loadStarted = false;
        if (preserve && (hadMedia || this.restore.wasPlaying)) {
          this.loadStarted = true;
          this.video.preload = 'metadata';
          this.video.load();
        } else {
          this.restore = null;
          this.video.preload = 'none';
          this.prepare();
        }
      }

      restoreSource() {
        if (!this.restore) return;
        const state = this.restore;
        this.restore = null;
        this.video.muted = state.muted;
        this.video.volume = state.volume;
        if (Number.isFinite(state.time)) {
          const duration = Number.isFinite(this.video.duration) ? this.video.duration : state.time;
          try { this.video.currentTime = Math.min(state.time, duration); } catch (_) { /* Native controls still support seeking. */ }
        }
        Array.from(this.video.textTracks || []).forEach((track, index) => {
          if (state.tracks[index]) track.mode = state.tracks[index];
        });
        if (state.wasPlaying && !this.manualPaused && this.inView && !document.hidden && (state.mode === 'user' || this.autoAllowed())) this.playVideo(state.mode);
        else this.prepare();
        this.updateControls();
      }

      prepare() {
        if (!this.events || !this.inView || document.hidden || !this.autoAllowed() || this.autoAttempted || this.manualPaused || this.restore) return;
        if (!this.loadStarted && this.video.readyState < 2) {
          this.loadStarted = true;
          this.video.preload = 'auto';
          this.video.load();
        }
        this.maybeAutoplay();
      }

      maybeAutoplay() {
        if (!this.events || !this.inView || document.hidden || !this.autoAllowed() || this.autoAttempted || this.manualPaused || this.restore || this.video.readyState < 2) return;
        this.autoAttempted = true;
        this.video.muted = true;
        this.playVideo('auto');
      }

      playVideo(mode) {
        if (!this.events) return;
        this.playMode = mode;
        const request = ++this.playRequest;
        this.video.play().then(() => {
          if (!this.events || request !== this.playRequest) return;
          if (mode !== 'user' && (!this.inView || document.hidden)) this.suspend();
          this.updateControls();
        }).catch(() => {
          if (this.events && request === this.playRequest) this.updateControls();
        });
      }

      suspend(cancelRestore = true) {
        this.playRequest += 1;
        if (cancelRestore && this.restore) this.restore.wasPlaying = false;
        if (!this.video.paused) {
          this.systemPauses += 1;
          this.video.pause();
        }
      }

      updateControls() {
        const playing = !this.video.paused && !this.video.ended;
        const quiet = this.video.muted || this.video.volume === 0;
        const playLabel = playing ? this.dataset.pauseLabel : this.dataset.playLabel;
        const soundLabel = quiet ? this.dataset.unmuteLabel : this.dataset.muteLabel;
        this.playButton.setAttribute('aria-label', playLabel);
        this.playButton.title = playLabel;
        this.playButton.querySelector('[data-play-label]').textContent = playLabel;
        this.playButton.querySelector('[data-play-icon]').toggleAttribute('hidden', playing);
        this.playButton.querySelector('[data-pause-icon]').toggleAttribute('hidden', !playing);
        this.soundButton.setAttribute('aria-label', soundLabel);
        this.soundButton.title = soundLabel;
        this.soundButton.querySelector('[data-sound-label]').textContent = soundLabel;
        this.soundButton.querySelector('[data-unmute-icon]').toggleAttribute('hidden', !quiet);
        this.soundButton.querySelector('[data-mute-icon]').toggleAttribute('hidden', quiet);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.events?.abort();
        this.viewport?.removeEventListener('change', this.onViewport);
        this.motion?.removeEventListener('change', this.onPreference);
        this.connection?.removeEventListener('change', this.onPreference);
        this.playRequest = (this.playRequest || 0) + 1;
        this.video?.pause();
        this.events = null;
        this.restore = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
